import { onMounted } from 'vue'

export const useLocalStorage = () => {
    const set = (key, value) => {
        localStorage.setItem(key, value)
    }
    const get = key => {
        return localStorage.getItem(key)
    }
    const remove = key => {
        localStorage.removeItem(key)
    }
    return {
        set,
        get,
        remove
    }
}

export const useFlash = () => {
    onMounted(() => {
        const messages = document.getElementsByClassName('alert-msg')

        Array.from(messages).map(v => {
            v.style.display = 'block'
            setTimeout(() => {
                v.style.display = 'none'
            }, 3000)
        })
    })

    return {}
}
